module.exports = __webpack_public_path__ + "img/vindi_logo.8ba775bd.svg";